import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { usePageTitle } from '../../utils/usePageTitle'
import { beginSsoLaunch } from './authHelpers'

export const SsoLaunchPage = () => {
	const [searchParams] = useSearchParams()
	const navigate = useNavigate()
	const idp = searchParams.get('idp') ?? undefined
	const loginHint = searchParams.get('login_hint') ?? undefined
	const targetLinkUri = searchParams.get('target_link_uri') ?? undefined
	const processed = React.useRef(false)

	usePageTitle()

	React.useEffect(() => {
		if (!processed.current) {
			processed.current = true
			beginSsoLaunch({ idp, loginHint, targetLinkUri }).catch(() => {
				navigate('/auth/login', { replace: true })
			})
		}
	}, [idp, loginHint, targetLinkUri, navigate])

	return (
		<div className='callback-container'>
			<h2>Signing in...</h2>
			<p>Please wait while we redirect you</p>
		</div>
	)
}
